<template>
  <div class="animated fadeIn">
    <b-card>
      <b-card-header>
        <i class="icon-menu mr-1"></i>優惠卷管理
        <div class="card-header-actions">
          <b-link @click="openEditor()"><i class="fa fa-plus"></i> 新增</b-link>
        </div>
      </b-card-header>
      <b-card-body>
      <v-server-table :columns="columns" :data="data" :options="options" :theme="theme" ref="dataTable" id="dataTable">
        <a slot="end_user_id" slot-scope="props" class="text-center w-100 d-inline-block">
          <span v-show="props.row.EndUser" class="text-warning"><b>已使用</b></span>
          <span v-show="!props.row.EndUser" class="text-success"><b>未使用</b></span>
        </a>
        <a slot="user_id" slot-scope="props">{{props.row.Admin.firstname + ' ' + props.row.Admin.lastname}}</a>
        <a slot="company_id" slot-scope="props">{{props.row.Company?props.row.Company.name:'N/A'}}</a>
        <a slot="created" slot-scope="props"  class="text-center w-100 d-inline-block">{{props.row.created|timedisplay}}</a>
        <a slot="modified" slot-scope="props"  class="text-center w-100 d-inline-block">
          <span v-if="props.row.EndUser && props.row.EndUser.name">使用時間：</span>
          {{props.row.modified|timedisplay}}
        </a>
        <a slot="valid_till" slot-scope="props"  class="text-center w-100 d-inline-block">{{props.row.modified|dateonly}}</a>
        <a slot="sn" slot-scope="props"  class="text-center w-100 d-inline-block"><b>{{props.row.sn}}</b></a>
        <a slot="type" slot-scope="props"  class="text-center w-100 d-inline-block">
          {{props.row.type === 'time' ? '優惠時間' : '優惠點數'}}
        </a>
        <a slot="amount" slot-scope="props"  class="text-center w-100 d-inline-block">
          {{props.row.type === 'time' ? `${props.row.amount}小時` : `${props.row.amount}元`}}
        </a>

        <div slot="child_row" slot-scope="props">
          <b-alert
            v-if="props.row.EndUser && props.row.EndUser.name"
            variant="info"
            show>
            優惠卷已使用，不可修改！
          </b-alert>
          <b-alert
            v-if="moment().tz(config.timezone).format('YYYY-MM-DD') > props.row.valid_till"
            variant="warning"
            show>
            優惠卷已過期，不可修改
          </b-alert>
          <b-button
            v-if="!props.row.EndUser && moment().tz(config.timezone).format('YYYY-MM-DD') <= props.row.valid_till"
            variant="success"
            class="btn-pill"
            size="sm" @click="editRow(props.row.id, props.row)"><i class="fa fa-pencil"></i> 修改</b-button> &nbsp;
          <b-button
            v-if="!props.row.EndUser && moment().tz(config.timezone).format('YYYY-MM-DD') <= props.row.valid_till"
            variant="danger"
            class="btn-pill"
            size="sm" @click="delRow(props.row.id, props.row.sn)"><i class="fa fa-times"></i> 取消</b-button> &nbsp;
          <!-- <b-button variant="warning" class="btn-pill" size="sm" @click="openLog(props.row.id)"><i class="fa fa-list"></i> 使用紀錄</b-button> &nbsp;
          <b-button class="btn-pill" size="sm" @click="testRow(props.row.id)"><i class="fa fa-usd"></i> 交易紀錄</b-button> &nbsp; -->
        </div>
      </v-server-table>
      </b-card-body>
    </b-card>

    <b-modal
      v-model="showEditorModal"
      ok-title="確定"
      cancel-title="取消"
      @ok="submitRecord">
      <b-form>
        <h1>優惠卷資料</h1>
        <p class="text-muted">綠框為必填</p>
        <b-input-group class="mb-3">
          <VueCtkDateTimePicker
            v-model="record.valid_till"
            :format="'YYYY-MM-DD'"
            :formatted="'YYYY-MM-DD'"
            label="有效期限"
            button-now-translation="現在時間"
            :min-date="minDate"
            :max-date="maxDate"
            :only-date="true"
            :noClearButton="true"
          />
        </b-input-group>

        <b-input-group class="mb-3">
          <b-input-group-prepend>
            <b-input-group-text><i class="fa fa-user"></i></b-input-group-text>
          </b-input-group-prepend>
          <b-form-input type="text" 
              class="form-control" 
              placeholder="客戶姓名" 
              v-model.lazy.trim="$v.record.name.$model"
              v-focus
              :state="chkState('name')"
              aria-describedby="invalidNameFeedback"/>
          <b-form-invalid-feedback id="invalidNameFeedback">名稱必填</b-form-invalid-feedback>
        </b-input-group>

        <b-input-group class="mb-3">
          <b-input-group-prepend>
            <b-input-group-text><i class="fa fa-qrcode"></i></b-input-group-text>
          </b-input-group-prepend>
          <b-form-input type="text" 
              class="form-control" 
              placeholder="優惠代碼" 
              v-model.lazy.trim="$v.record.sn.$model"
              v-focus
              readyonly
              disabled
              :state="chkState('sn')"
              aria-describedby="invalidSNFeedback"/>
          <b-form-invalid-feedback id="invalidSNFeedback">優惠代碼必填</b-form-invalid-feedback>
        </b-input-group>

        <b-input-group class="mb-3">
          <b-input-group-prepend>
            <b-input-group-text><i class="fa fa-question"></i></b-input-group-text>
          </b-input-group-prepend>
          <b-form-select
            v-model="record.type"
            :options="type_options">
          </b-form-select>
        </b-input-group>

        <b-input-group class="mb-3">
          <b-input-group-prepend>
            <b-input-group-text><i class="fa fa-usd"></i></b-input-group-text>
          </b-input-group-prepend>
          <b-form-input type="number" 
              class="form-control" 
              placeholder="數量(單位為點)" 
              v-model.lazy.trim="$v.record.amount.$model"
              v-focus
              :state="chkState('amount')"
              aria-describedby="invalidAmountFeedback"/>
          <b-form-invalid-feedback id="invalidAmountFeedback">數量必填</b-form-invalid-feedback>
        </b-input-group>

        <b-input-group class="mb-3">
          <b-input-group-prepend>
            <b-input-group-text><i class="fa fa-car"></i></b-input-group-text>
          </b-input-group-prepend>
          <b-form-input type="text"
              v-model="record.plate" 
              class="form-control" 
              placeholder="車牌號碼"/>
        </b-input-group>

        <b-input-group class="mb-3">
          <b-input-group-prepend>
            <b-input-group-text><i class="fa fa-pencil"></i></b-input-group-text>
          </b-input-group-prepend>
          <b-form-input type="text"
              v-model="record.remarks" 
              class="form-control" 
              placeholder="備註（如消費時的發票號碼等）"/>
        </b-input-group>
              
      </b-form>
    </b-modal>

    <b-modal title="取消優惠卷" size="sm" v-model="delRowShowModal" @ok="submitDelRow(delRowId)" ok-title="確定" cancel-title="取消">
      {{delRowMsg}}
    </b-modal>
    
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import {ServerTable, Event} from 'vue-tables-2'
import { required, minLength, maxLength, between, email, minValue, integer } from 'vuelidate/lib/validators'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import Multiselect from 'vue-multiselect'
import vSelect from 'vue-select'
import config from '@/config/global'
import notifications from '@/config/notifications'
import jQuery from 'jquery'
import select2 from 'select2'
// import qrcode from 'qrcode'
import sha1 from 'sha1'
import io from 'socket.io-client'
import _ from 'lodash'
import moment from 'moment-timezone'
import QRious from 'qrious'

const encrypt    = config.encrypt;
const decrypt    = config.decrypt;
const admin_root = config.admin_root;

let $socket = null;

const clean_form = {
  name:       '',
  sn:         '',
  type:       'credit',
  amount:     '',
  plate:      '',
  remarks:    '',
  valid_till: moment().tz(config.timezone).format('YYYY-MM-DD'),
};

Vue.use(ServerTable)

export default {
  name: 'coupon',
  notifications,
  components: {
    ServerTable,
    Event,
    Multiselect,
    vSelect,
    VueCtkDateTimePicker,
  },
  data(){

    let app = this;
    let cannotEdit = false;
    let record = Object.assign({}, clean_form);

    record.sn = Math.round(100000 + Math.random() * 999911).toString();
    record.type = 'credit';

    return {
      moment,
      config,
      demo_options: [
        {label:'YES', value:'YES'},
        {label:'NO', value:'NO'}
      ],
      hide_demo_option: cannotEdit,
      cannotEdit,
      device_uri: '',
      showQrCode: false,
      showLogList: false,
      selected_row: null,
      isFindingLoading: false,
      editRowId: null,
      record,
      showEditorModal: false,
      delRowShowModal: false,
      delRowId: 0,
      delRowMsg: '',
      minDate: moment().tz(config.timezone).format('YYYY-MM-DD'),
      maxDate: moment().tz(config.timezone).add(0, 'days').format('YYYY-MM-DD'),
      type_options: [
        // { value: 'time', text: '折抵時間' },
        { value: 'credit', text: '優惠點數' },
      ],
      columns: [
        'id',
        'name',
        'sn',
        'end_user_id',
        'plate',
        'type',
        'amount',
        'remarks',
        'valid_till',
        'user_id',
        'created',
        'modified'
      ],
      logcolumns: ['user_id', 'start_time', 'end_time', 'status', 'interval', 'used_watts', 'sub_total', 'created'],
      data: [],
      logdata:[],
      options: {
        headings: {
          id: '#',
          name: '顧客姓名',
          sn: '優惠代碼',
          end_user_id: '顧客已使用？',
          // device_id: '使用裝置',
          plate: '車牌',
          type: '類型',
          amount: '數量',
          remarks: '備註',
          valid_till: '有效期限',
          user_id: '建立人員',
          created: '建立時間',
          modified: '修改時間',
        },
        orderBy: {
          column: 'created',
          ascending: false
        },
        sortable: [
          'id',
          'name',
          'sn',
          'end_user_id',
          // 'device_id',
          'plate',
          'type',
          'amount',
          'remarks',
          'valid_till',
          'user_id',
          'created',
          'modified'
        ],
        filterable: [
          'id',
          'name',
          'sn',
          'plate',
          'type',
          'amount',
        ],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        pagination: {
          chunk: 5,
          edge: false,
          nav: 'scroll'
        },
        perPage: 25,
        requestFunction(data) {
          let action = `${admin_root}/get_list/Coupon`;
          let params = {
            keyset: 'mqtt'
          };

          let ccff = this.$state.$get('ccff');
          if(ccff){
            params['ccff'] = ccff;
          }

          for(let col in data){
            params[col] = '' + data[col];
          }

          return fetch(action, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
            },
            body: JSON.stringify(params)
          }).then(res => res.json()).then(result => {
            return {
              data: result.data || [],
              count: result.count || 0
            };
          }).catch(error => {
            return {
              data: [],
              count: 0
            };
          });
        }//eo requestFunction
      },
      useVuex: false,
      theme: 'bootstrap4',
      template: 'default',
    };//eo return
  },//eo data

  mounted(){
    let app = this;

    $socket = io(config.socket_entry, {
      origins: '*:*',
      secure: true,
      forceNew: true,
      transports: ['polling'],
      cookie: false,
    });
    $socket.on('connect', () => {
      console.info('socket connected...');
    });

    $socket.on('mqtt_connected', (data) => {
      if(data.message.indexOf('&') !== -1){
        let parsed = config.mqtt_msg_parser(data.message);

        // console.info('mqtt parsed:', parsed);

        if(parsed && parsed.deviceid){
          jQuery('#PHolder'+parsed.deviceid).html('<span class="text-success"><i class=" fa fa-check"></i></span>')
        } else {
          jQuery('#PHolder'+parsed.deviceid).html('<span class="text-danger"><i class=" fa fa-times"></i></span>')
        }
      }
    });
    
    this.handler = function(records) {
      // console.info('vue-tables.loaded:', records);
    };
    Event.$on('vue-tables.loaded', this.handler);
  },

  beforeDestroy() {
    Event.$off('vue-tables.loaded', this.handler);
  },

  methods: {

    editRow(row_id, row) {
      // console.info('edit row_id:', row_id);
      this.selected_row = row;
      this.openEditor(row_id);

      this.selected_row['serialno'] = row['sn'];

      if(this.selected_row['end_user_id'] == 0){
        this.selected_row['end_user_id'] = '';
      }

      this.record = Object.assign({}, this.selected_row);
    },//eo editRow

    delRow(row_id, row_name) {
      // console.info('del row_id:', row_id);

      this.delRowShowModal = row_id ? true : false;
      this.delRowId        = row_id;
      this.delRowMsg       = `您確定要取消${row_name}這張優惠券嗎？`;
    },//eo delRow

    submitDelRow(row_id) {
      
      let app    = this;
      let action = `${admin_root}/update_coupon`;
      let params = {
          keyset: 'mqtt',
          record: encodeURIComponent(encrypt(JSON.stringify({
            id: row_id,
            field: 'valid',
            value: 0,
            value_type: 'int'
          })))
      };

      fetch(action, {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
        },
        body: JSON.stringify(params)
      }).then(res => res.json()).then(result => {
        if(result.success){
          app.showSuccess({
            title: '資料更新成功',
            message: result.message
          });

          app.$refs['dataTable'].refresh();
        } else {
          app.showError({
            title: '資料更新失敗',
            message: result.message
          });
        }
      }).catch(error => {
        app.showError({
          title: '資料更新失敗',
          message: result.message
        });
      });
    },

    testRow(row_id) {
      console.info('test row_id:', row_id);
      this.showWarn({
        message: '開發中',
        title: '功能暫停'
      });
    },//eo testRow

    chkState(val) {
      const field = this.$v.record[val];

      return !field.$dirty || !field.$invalid;
    },

    openEditor(row_id){
      this.editRowId       = row_id;
      this.showEditorModal = true;
      this.$v.$reset();

      let page_limit = 10;
      let app        = this;

      if (!row_id) {
        this.record = { ...clean_form };
        this.record.sn = Math.round(100000 + Math.random() * 999911).toString();
        this.record.type = 'credit';
        this.record.valid_till = moment().tz(config.timezone).format('YYYY-MM-DD');
        this.minDate = moment().tz(config.timezone).format('YYYY-MM-DD');
        this.maxDate = moment().tz(config.timezone).add(0, 'days').format('YYYY-MM-DD');
      }
      
    },// eo openEditor

    submitRecord(event) {

      let app    = this;
      let row_id = app.editRowId;

      this.$v.$touch();

      if (this.$v.$invalid) {
        this.showError({message:'請輸入必填欄位', title:'資料錯誤'});
        event.preventDefault();
        return false;
      }

      if (this.record.amount <= 0) {
        this.record.amount = '';
        this.showError({message:'數量不可為負值', title:'數量錯誤'});
        event.preventDefault();
        return false;
      }
          
      if (this.record.type === 'time' && this.record.amount > 3) {
        this.record.amount = '';
        this.showError({message:'當優惠卷為折抵時間時，數量不能超過3個小時', title:'折抵數量過多'});
        event.preventDefault();
        return false;
      }

      if (this.record.type === 'credit' && this.record.amount > 300) {
        this.record.amount = '';
        this.showError({message:'數量不能超過300點', title:'數量過多'});
        event.preventDefault();
        return false;
      }

      let to_save = this.record;

      if(row_id){
        to_save['id'] = row_id;
      }

      to_save['serialno'] = to_save.sn;

      to_save = encodeURIComponent(encrypt(JSON.stringify(to_save)));

      let action = `${admin_root}/save_coupon`;
      let params = {
        keyset: 'mqtt',
        record: to_save
      };

      fetch(action, {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.$state.$get('adminuser').token
        },
        body: JSON.stringify(params)
      }).then(res => res.json()).then(result => {
        if(result.success){
          app.showSuccess({
            title: '成功',
            message: '資料成功儲存'
          });
          app.$refs['dataTable'].refresh();
          app.record = Object.assign({}, clean_form);
          app.$v.$reset();
        } else {
          app.showError({
            title: '錯誤',
            message: '無法儲存資料，請稍後再試'
          });
          app.$refs['dataTable'].refresh();
        }
      }).catch(error => {
        app.showError({
          title: '錯誤',
          message: '無法儲存資料，請稍後再試'
        });
        app.$refs['dataTable'].refresh();
      });
    },

    genRow(row_id) {
      // console.info('row clicked: ', row_id);
      this.showQrCode = true;
      row_id          = encodeURIComponent(config.encrypt(row_id, config.ffkey, config.ffiv));

      let msg = `${config.frontend}?uuid=${row_id}`;
          
          // console.info('msg:', msg);
      
          (new QRious({
              element: document.getElementById('qrcode-canvas'),
              value: msg,
              size: 160
          }));
          
          this.device_uri = `${config.frontend}?uuid=${row_id}`;
    },//eo onRowClick

    openLog(device_id){
      let app = this;
      app.target_device_id = device_id;
      app.showLogList = true;

      app.$refs['logDataTable'].refresh();
    },
  },//eo methods

  validations: {
    record: {
      name: {
        required,
        minLength: minLength(2)
      },
      sn: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(6),
      },
      type: {
        required,
      },
      valid_till: {
        required,
      },
      amount: {
        required,
        minValue: minValue(0),
      }
    }
  },//eo validations
  
};
</script>
<style lang="scss">
.card-body{padding:0;}
.add-btn{}
.help-text{margin-top: 0.5rem; margin-left: 0.8rem;}
.multiselect__input{width:100%;border:none;}
#qrcode-canvas{
  display:inline-block;
  margin: auto;
}
#dataTable {
  width: 95%;
  margin: 0 auto;
  margin-top: 0.5rem;
  font-size: 0.75rem;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .vue-title {
    text-align: center ;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.25rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }

  .VueTables__child-row-toggler--open::before {
    content: "-";
  }

  .VueTables__sortable {
    padding: 0.25rem;
  }
}

</style>
